import { IconProps } from '../types';

function ColorBucketSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      className={className || 'h-6 w-6'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18,15.3c0,0.8-0.8,1.7-1.7,1.7c-0.8,0-1.7-0.8-1.7-1.7c0-1.7,0.8-2.5,1.7-3.3C17.2,12.8,18,13.7,18,15.3z M15.4,11l-6,6 C9,17.4,8.5,17.6,8,17.6S7,17.4,6.6,17L2,12.4C1.6,12,1.4,11.5,1.4,11S1.6,10,2,9.6L6.6,5L5.3,3.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0 L15.4,11z M3.4,11h9.2L8,6.4L3.4,11z"
      />
    </svg>
  );
}

export default ColorBucketSolidIcon;
